import React from "react";
import CollapsibleHtmlContent from "components/common/CollapsibleHtmlContent";
import HtmlContent from "components/common/HtmlContent";

interface CourseBodyProps {
  content: string;
  seoCollapsibleContent?: {
    __typename: "Course_Seocollapsiblecontent";
    html: string | null;
  } | null;
}

export default function CourseBody({ content, seoCollapsibleContent }: CourseBodyProps) {
  return (
    <>
      <HtmlContent>{content}</HtmlContent>
      {seoCollapsibleContent?.html && <CollapsibleHtmlContent html={seoCollapsibleContent.html} />}
    </>
  );
}
